export default "__VITE_ASSET__CbtRUK5a__"